import React, { Component } from 'react';
import { SignUp } from '$components/auth';
import { fetchAll as fetchSectors } from '$actions/sectors';
import { create as createAccount, login } from '$actions/accounts';
import { changeTitle } from '$actions/root';
import { sectorsSelector, formSelector } from '$selectors';
import { connect } from 'react-redux';
import { getRoles } from '../../api';
import {Translate} from "$common";

@connect(state => ({
 sectors: sectorsSelector(state),
 form: formSelector(state, 'signup')
}), { fetchSectors, createAccount, login, changeTitle })
export default class SignUpRoute extends Component {
  state = {
    roles: null
  };

  async getRoles() {
    const { data: roles } = await getRoles();
    this.setState({ roles });
  }

  componentWillMount() {
    this.getRoles();
    this.props.fetchSectors();
    this.props.changeTitle(Translate.get('sign_up'))
  }

  render() {
   const { sectors, form, createAccount, login } = this.props;
   const { roles } = this.state;

   return (
     <SignUp
       sectors={sectors || []}
       errors={form.errors}
       onCreate={createAccount}
       onLogin={login}
       roles={roles}
       defaults={this.props.location.query}
     />
   )
  }
}



// WEBPACK FOOTER //
// ./src/routes/auth/signup.js